import {
  CardPaymentStatus,
  ICardPaymentDetails,
  JuniferPaymentStatus,
  PaymentNotificationStatus,
} from "./cardPaymentDetails.types"

export class CardPaymentDetails implements ICardPaymentDetails {
  constructor(
    public status: CardPaymentStatus,
    public notificationStatus: PaymentNotificationStatus,
    public juniferPaymentStatus: JuniferPaymentStatus,
    public amountInPence: number,
    public reference: string,
    public errorCode?: string,
    public errorMessage?: string,
    public notificationError?: string,
  ) {}
}
